export const toLocalISODate = (val) => {
  if (!val) return "";
  const d = val instanceof Date ? val : new Date(val);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
};

export const formatISOToDDMMYYYY = (iso) => {
  if (!iso || typeof iso !== "string") return "";
  const m = iso.match(/^\d{4}-\d{2}-\d{2}$/);
  if (!m) return "";
  const [y, mm, dd] = iso.split("-");
  return `${dd}-${mm}-${y}`;
};

export const parseDDMMYYYYToISO = (val) => {
  if (!val || typeof val !== "string") return "";
  const s = val.trim();
  const m = s.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
  if (!m) return "";
  const dd = parseInt(m[1], 10);
  const mm = parseInt(m[2], 10);
  const yyyy = parseInt(m[3], 10);
  if (mm < 1 || mm > 12) return "";
  if (dd < 1 || dd > 31) return "";
  const iso = `${String(yyyy).padStart(4, "0")}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return "";
  if (toLocalISODate(d) !== iso) return "";
  return iso;
};

export const addDaysLocal = (dateObj, days) => {
  const d = new Date(dateObj);
  d.setDate(d.getDate() + days);
  return d;
};

export const getEasterSundayUTC = (year) => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));
};

export const getZAPublicHolidaysSet = (year) => {
  const holidays = [];

  holidays.push(new Date(year, 0, 1));
  holidays.push(new Date(year, 2, 21));

  const easterSundayUTC = getEasterSundayUTC(year);
  const easterSundayLocal = new Date(
    easterSundayUTC.getUTCFullYear(),
    easterSundayUTC.getUTCMonth(),
    easterSundayUTC.getUTCDate()
  );
  holidays.push(addDaysLocal(easterSundayLocal, -2));
  holidays.push(addDaysLocal(easterSundayLocal, 1));

  holidays.push(new Date(year, 3, 27));
  holidays.push(new Date(year, 4, 1));
  holidays.push(new Date(year, 5, 16));
  holidays.push(new Date(year, 7, 9));
  holidays.push(new Date(year, 8, 24));
  holidays.push(new Date(year, 11, 16));
  holidays.push(new Date(year, 11, 25));
  holidays.push(new Date(year, 11, 26));

  const set = new Set();
  for (const h of holidays) {
    const iso = toLocalISODate(h);
    if (iso) set.add(iso);

    const day = h.getDay();
    if (day === 0) {
      const observed = toLocalISODate(addDaysLocal(h, 1));
      if (observed) set.add(observed);
    }
  }
  return set;
};

export const isClosedDateLocal = (isoDate) => {
  if (!isoDate) return false;
  const d = new Date(`${isoDate}T00:00:00`);
  if (Number.isNaN(d.getTime())) return false;

  const dow = d.getDay();
  if (dow === 0) return true;

  const holidaySet = getZAPublicHolidaysSet(d.getFullYear());
  return holidaySet.has(isoDate);
};

export const getOperatingHoursForDateLocal = (isoDate) => {
  if (!isoDate) return null;
  if (isClosedDateLocal(isoDate)) return null;

  const d = new Date(`${isoDate}T00:00:00`);
  const dow = d.getDay();

  if (dow >= 1 && dow <= 5) {
    return { startMin: 9 * 60, endMin: 13 * 60 };
  }

  if (dow === 6) {
    return { startMin: 9 * 60, endMin: 12 * 60 };
  }

  return null;
};

export const toISODateUTC = (val) => {
  if (!val) return "";
  const d = val instanceof Date ? val : new Date(val);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(d.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
};

export const toHMUTC = (val) => {
  if (!val) return "";
  const d = val instanceof Date ? val : new Date(val);
  const h = String(d.getUTCHours()).padStart(2, "0");
  const mm = String(d.getUTCMinutes()).padStart(2, "0");
  return `${h}:${mm}`;
};

export const hhmmToMinutes = (s) => {
  if (!s || typeof s !== "string" || !/^[0-2]?\d:[0-5]\d$/.test(s)) return null;
  const [h, m] = s.split(":");
  return parseInt(h, 10) * 60 + parseInt(m, 10);
};

export const minutesToHHMM = (m) => {
  const hh = String(Math.floor(m / 60)).padStart(2, "0");
  const mm = String(m % 60).padStart(2, "0");
  return `${hh}:${mm}`;
};
